<template>
  <b-modal
    :visible="isOpen"
    id="add-init"
    size="xl"
    title="ADD REPAIR & MAINTENANCE"
    header-bg-variant="light"
    header-text-variant="dark"
    footer-bg-variant="light"
    footer-text-variant="dark"
    @hide="$emit('close')"
    ok-title="Next"
    @ok="fleets.checked ? $emit('next', fleets.checked) : showAlert"
  >
    <b-row class="mb-4">
      <b-col md="4" class="text-right">
        <b-form-input
          type="text"
          placeholder="Search fleets..."
          v-model="fleets.params.search"
          @input="fetchFleets"
        ></b-form-input>
      </b-col>
    </b-row>
    <div v-if="fleets.loading" class="text-center my-5">
      <b-spinner type="grow" label="Spinning"></b-spinner>
    </div>
    <template v-else>
      <div
        v-if="fleets.data?.length > 0"
        style="max-height: 68vh; overflow: auto"
      >
        <b-row>
          <b-col
            md="3"
            class="text-center py-5 border-top"
            v-for="(fleet, i) in fleets.data"
            :key="`fleet-${i}`"
          >
            <div class="custom-control custom-radio image-checkbox">
              <input
                :id="`ck-fl-${i}`"
                type="radio"
                class="custom-control-input"
                :value="fleet.id"
                v-model="fleets.checked"
              />
              <label class="custom-control-label" :for="`ck-fl-${i}`">
                <img
                  :src="
                    fleet.vehicleType.icon.url
                      | checkPhoto(
                        require('@src/assets/images/fleet/PusherBarge.png')
                      )
                  "
                  alt="#"
                  class="img-fluid"
                />
              </label>
              <small>
                <strong>{{ fleet.name }}</strong>
              </small>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else class="text-center my-5">
        <p class="mb-0 text-muted">No fleets data found.</p>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { fleetsActions } from '@/src/Utils/helper'
import _ from 'lodash'

export default {
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      fleets: {
        checked: null,
        data: [],
        loading: false,
        params: {
          page: 1,
          limit: 999,
          search: '',
          showAll: true,
          active: true,
        },
      },
    }
  },
  created() {
    // Membuat fungsi debounce
    this.fetchFleets = _.debounce(this.fetchFleets, 500)
  },
  methods: {
    ...fleetsActions,
    async fetchFleets() {
      this.fleets.loading = true
      let params = this.$options.filters.cleanObject(this.fleets.params)
      let res = await this.getFleets(params)
      if (!res.status) {
        this.fleets.loading = false
        this.fleets.data = []
      } else {
        this.fleets.loading = false
        this.fleets.data = res.data
      }
    },
    showAlert() {
      this.$swal('Gagagl!!', 'Pilih Kapal Terlebih Dahulu!', 'error')
    },
  },
  mounted() {
    this.fetchFleets()
  },
}
</script>
